/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./Factory"], function (require, exports, Factory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ActionsCreatorManager = /** @class */ (function (_super) {
        __extends(ActionsCreatorManager, _super);
        function ActionsCreatorManager() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        /**
         * Get an instance of the action creator. Use action creator in cases where data needs
         * to be fetched from source before invoking an action.
         */
        ActionsCreatorManager.GetActionCreator = function (actionCreatorClass, instanceId) {
            return _super.getInstance.call(this, ActionsCreatorManager).getObject(actionCreatorClass, instanceId);
        };
        ActionsCreatorManager.CreateActionCreator = function (actionCreatorClass, instanceId, args) {
            return _super.getInstance.call(this, ActionsCreatorManager).createObject(actionCreatorClass, instanceId, args);
        };
        ActionsCreatorManager.DeleteActionCreator = function (actionCreatorClass, instanceId) {
            _super.getInstance.call(this, ActionsCreatorManager).removeObject(actionCreatorClass, instanceId);
        };
        ActionsCreatorManager.dispose = function () {
            return _super.getInstance.call(this, ActionsCreatorManager).dispose();
        };
        return ActionsCreatorManager;
    }(Factory_1.Manager));
    exports.ActionsCreatorManager = ActionsCreatorManager;
});
